<template>
  <div id="app">
    <div class="bty">
      <!-- pc端 -->
      <div class="left">
        <div id="slot" class="slot">
          <div class="s-logo">
            <router-link to="/">
              <img src="@/assets/logo.png" class="logo"></img>
            </router-link>
          </div>
          <div class="s-search">
            <input type="text" placeholder="搜索视频" @keyup.enter="getsearch" v-model="searchText"
                   class="bar">
            <span class="sec cuIcon-search">  <img src="@/assets/icon/8.png" style="width: 15px;height: 15px"></span>
          </div>
          <div class="s-menus">
            <div class="item  cuIcon-text" v-for="(item,index) in categoriesList"
                 @click="getlike(item.id)">
              <img src="@/assets/icon/5.png" style="width: 14px;height: 14px">
              <a class="ax ">{{ item.title }}</a>
              <span style="background: #343a41;padding: 1% 3%;border-radius: 10px;font-size: 13px">{{item.video_count}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 手机端 -->
      <div class="top">
        <div class="navgation">
          <div class="ix nav-left">
            <div class="cuIcon-apps" @click="show=true" style="display: flex">
              <img src="@/assets/icon/02.png" style="width: 15px;height: 15px">
              <p style="font-size: 16px;margin-left: 3px;line-height: 15px;">菜单</p>

            </div>
          </div>
          <div class="ix middle">
            <router-link to="/">
              <img src="@/assets/logo.png" class="logo"></img>
            </router-link>
          </div>
          <div class="ix nav-right">

          </div>
        </div>

        <!-- 手机端分类 -->
        <div data-transfer="true" v-show="show">
          <div class="ivu-drawer-mask" @click="show =false"></div>

          <div class="ivu-drawer-wrap">
            <div class="ivu-drawer ivu-drawer-left" style="width:256px;">
              <div class="ivu-drawer-content">
                <div class="ivu-drawer-header">
                  <div class="ivu-drawer-header-inner">分类选择</div>
                </div>
                <div class="ivu-drawer-body">
                  <div class="drawer-left">
                    <div class="search">
                      <input type="text" placeholder="搜索视频" @keyup.enter="getsearch" v-model="searchText" value=""
                             class="bar">
                      <span class="sec cuIcon-search">  <img src="@/assets/icon/8.png" style="width: 15px;height: 15px"></span>
                    </div>

                    <div class="menus">
                      <div class="item  cuIcon-text" v-for="(item,index) in categoriesList"
                           @click="getlike(item.id)">
                        <img src="@/assets/icon/6.png" style="width: 14px;height: 14px">
                        <a class="ax ">{{ item.title }}</a>
                        <span style="background: #ebebeb;padding: 1% 3%;border-radius: 10px;font-size: 13px">{{item.video_count}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center">
        <router-view :key="$route.fullPath"/>
      </div>

    </div>

  </div>
</template>

<style>
@import './assets/styles/common.css';
</style>

<script>

import api from '@/api'; // 假设你的api文件在src目录下

export default {
  data() {
    return {
      categoriesList: [],
      show: false,
      searchText: ''
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      api.get('/apiv1/7979vip/categories').then(res => {
        this.categoriesList = res.data.categories; // 假设响应数据直接是你需要展示的数据
      }).catch(error => {
        console.error('There was an error!', error);
      });
    },

    getlike(id) {
      this.show = false
// 定义目标路由信息（可带参数）
      const targetRoute = {
        path: '/list',
        // 可选参数示例：
        query: {categoriesid: id},
      }
// 核心路由跳转逻辑
      if (
          // 检查当前路径是否为/list
          this.$route.path !== '/list' ||
          // 深度比对当前参数与目标值
          this.$route.query.categoriesid != id
      ) {
        this.$router.push(targetRoute)
      }
    },

    // 搜索
    getsearch() {
      this.show = false
      // 定义目标路由信息（可带参数）
      if (this.searchText !== '') {
        const targetRoute = {
          path: '/list',
          // 可选参数示例：
          query: {searchText: this.searchText||''},
        }
        // 核心路由跳转逻辑
        this.$router.push(targetRoute)
      } else {
        this.$router.push('/')
      }
      this.searchText = ''
    }
  }

};
</script>